export default __webpack_public_path__ + "static/media/2.63fe74e2.mp3";